<!-- src/app/commons/toast/toast.component.html -->
<div class="fixed top-4 right-4 z-101 space-y-3 max-w-xs w-full">
  <div *ngFor="let toast of toasts" 
       [@toastAnimation]="'visible'"
       class="rounded-lg px-4 py-3 shadow-lg flex items-center justify-between"
       [ngClass]="{
         'bg-mint/10 border border-mint text-forest': toast.type === 'success',
         'bg-red-50 border border-red-200 text-red-600': toast.type === 'error',
         'bg-blue-50 border border-blue-200 text-blue-600': toast.type === 'info',
         'bg-amber-50 border border-amber-200 text-amber-600': toast.type === 'warning'
       }">
    <div class="flex items-center gap-3">
      <!-- Success Icon -->
      <svg *ngIf="toast.type === 'success'" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
      </svg>
      
      <!-- Error Icon -->
      <svg *ngIf="toast.type === 'error'" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
      </svg>
      
      <!-- Info Icon -->
      <svg *ngIf="toast.type === 'info'" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      
      <!-- Warning Icon -->
      <svg *ngIf="toast.type === 'warning'" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
      </svg>
      
      <span>{{ toast.message }}</span>
    </div>
    <button (click)="closeToast(toast.id)" class="ml-3 text-gray-400 hover:text-gray-600 transition-colors duration-300">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </button>
  </div>
</div>